import { useState, useEffect } from 'react';
import './Navbar.css';
import hamBtn from './hamburger-menu.svg';

function Navbar() {
  const [showLinks, setShowLinks] = useState(true);
  const [showHamBtn, setShowHamBtn] = useState(false);

  const handleClick = () => {
    setShowLinks(!showLinks);
  };

  window.addEventListener('resize', (e) => {
    if (e.target.innerWidth > 768) {
      setShowHamBtn(false);
      setShowLinks(true);
    } else {
      setShowHamBtn(true);
      setShowLinks(false);
    }
  });

  useEffect(() => {
    if (window.innerWidth > 768) {
      setShowHamBtn(false);
      setShowLinks(true);
    } else {
      setShowHamBtn(true);
      setShowLinks(false);
    }
  }, []);

  return (
    <nav className='navbar-container'>
      <div className='navbar-name'>
        <p>Tatiana Ivanova</p>
        {showHamBtn && (
          <img
            alt='hamburger menu'
            src={hamBtn}
            onClick={handleClick}
          />
        )}
      </div>
      {showLinks && (
        <div className='navbar-links-container'>
          <a
            href='#home'
            onClick={handleClick}
          >
            Home
          </a>
          <a
            href='#about'
            onClick={handleClick}
          >
            About me
          </a>
          <a
            href='#techs'
            onClick={handleClick}
          >
            Technologies
          </a>
          <a
            href='#portfolio'
            onClick={handleClick}
          >
            Portfolio
          </a>
          <a
            href='#contact'
            onClick={handleClick}
          >
            Contact
          </a>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
